import { isWWWinURL } from './helper';

export const APP_PATH = process.env.PUBLIC_URL;
export const INTEGRATOR_ID = process.env.REACT_APP_INTEGRATOR_ID;
export const API_URL = (process.env.NODE_ENV === 'production') && isWWWinURL()
  ? 'https://www.dinkassa.se/api'
  : process.env.REACT_APP_API_URL;